export const subscriptionsEndpoint =
  '/movimenti-conto-ms/ms/gntn/subscriptions';
export const putSubscriptionResourceId = 'putSubscriptionResourceId';
export const subscriptionEndpoint = '/movimenti-conto-ms/ms/gntn/subscription/';
